import React from 'react';
import './index.scss';

/**
 * Input
 */
function Input(props) {
  return <input className={'Input'} {...props} />;
}

Input.propTypes = {};
Input.defaultProps = {};

export default Input;
